import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  MEDICAL_INSURANCE = "Medical insurance",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal allowance",
  LIVING_ACCOMMODATION = "Living accommodation",
  REMOTE_WORK = "Remote work",
  GYM = "Gym",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.MEAL_ALLOWANCE]: {
    text: "Amounts under €11 per day are tax exempt.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
